import reducer from "./reducer";
export { default as MyPending } from "./components/index";
export { default as myPendingReducerName } from "./constants";
export default reducer;
